var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotion5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8476_3699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "url(#paint0_radial_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9062 51.3125C66.7321 51.3125 72.2656 45.779 72.2656 38.9531C72.2656 32.1272 66.7321 26.5938 59.9062 26.5938C53.0804 26.5938 47.5469 32.1272 47.5469 38.9531C47.5469 45.779 53.0804 51.3125 59.9062 51.3125Z",
    fill: "url(#paint1_radial_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 51.3125C26.7634 51.3125 32.2969 45.779 32.2969 38.9531C32.2969 32.1272 26.7634 26.5938 19.9375 26.5938C13.1116 26.5938 7.57812 32.1272 7.57812 38.9531C7.57812 45.779 13.1116 51.3125 19.9375 51.3125Z",
    fill: "url(#paint2_radial_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7344 18.3906C4.93749 11.5 -1.17189 22.2343 2.54686 29.2812C2.54686 29.2812 4.46874 33.5625 12.3437 36.7343C14.3906 37.5625 16.8437 38.3125 19.7969 38.9375C20.1094 39 20.4531 38.9375 20.7187 38.7343C23.125 36.9375 25.0312 35.2031 26.5469 33.5937C32.3594 27.4062 32.2969 22.7031 32.2969 22.7031C32.6875 14.7656 22.625 7.59372 15.7344 18.3906Z",
    fill: "url(#paint3_linear_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2657 18.3906C75.0625 11.5 81.1719 22.2343 77.4532 29.2812C77.4532 29.2812 75.5313 33.5625 67.6563 36.7343C65.6094 37.5625 63.1563 38.3125 60.2032 38.9375C59.8907 39 59.5469 38.9375 59.2813 38.7343C56.8751 36.9375 54.9688 35.2031 53.4532 33.5937C47.6407 27.4062 47.7032 22.7031 47.7032 22.7031C47.3126 14.7656 57.3751 7.59372 64.2657 18.3906Z",
    fill: "url(#paint4_linear_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1563 19.9689C67.4219 17.0158 71.7188 16.3595 74.8125 18.7189C77.8907 21.0939 78.4532 26.0939 76.1875 29.047C73.9219 32.0001 69.5782 32.4845 66.5 30.1095C63.4063 27.7345 62.8907 22.922 65.1563 19.9689Z",
    fill: "url(#paint5_radial_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 51.9217C32.0781 51.9217 24.4531 51.2185 17.3281 49.9217C16.6563 49.7967 16.0781 50.406 16.2188 51.0779C18.5313 62.0935 28.3125 70.3592 40.0156 70.3592C51.7188 70.3592 61.4844 62.0935 63.8125 51.0779C63.9531 50.406 63.375 49.8123 62.7031 49.9217C55.5469 51.2185 47.9219 51.9217 40 51.9217Z",
    fill: "url(#paint6_linear_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4844 67.4531C48.0625 69.2969 44.1562 70.3438 40 70.3438C35.8438 70.3438 31.9375 69.2969 28.5156 67.4531C30.6719 64.1875 35.0156 61.9688 40 61.9688C44.9844 61.9688 49.3281 64.2031 51.4844 67.4531Z",
    fill: "url(#paint7_linear_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6719 49.906C55.5469 51.2029 47.9219 51.906 40 51.906C32.0781 51.906 24.4531 51.2029 17.3281 49.906C16.6563 49.781 16.0781 50.3904 16.2188 51.0623C16.4531 52.156 16.75 53.2342 17.125 54.2654C23.6094 57.031 31.5 58.656 40 58.656C48.5156 58.656 56.4063 57.031 62.875 54.2654C63.25 53.2342 63.5625 52.156 63.7813 51.0623C63.9375 50.3904 63.3438 49.781 62.6719 49.906Z",
    fill: "url(#paint8_linear_8476_3699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89052 29.9531C1.9374 27.6875 1.28115 23.3906 3.64052 20.2968C5.9999 17.2031 11.0155 16.6562 13.9686 18.9218C16.9218 21.1875 17.4061 25.5312 15.0311 28.6093C12.6561 31.7031 7.84364 32.2187 4.89052 29.9531Z",
    fill: "url(#paint9_radial_8476_3699)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8476_3699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 40) scale(42.6073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFEA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#FFE273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#FFD361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFBF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFA629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#FF8804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#FF9C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#FFB53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FFD766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED81"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8476_3699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9094 38.9586) scale(13.7067 13.7067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#F78100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8476_3699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9394 38.9586) scale(13.7067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#F78100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8476_3699",
    x1: 14.8666,
    y1: 14.8771,
    x2: 21.0041,
    y2: 42.6382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60B15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8476_3699",
    x1: 65.1108,
    y1: 14.8854,
    x2: 58.9753,
    y2: 42.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60B15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8476_3699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.733 24.501) rotate(-167.53) scale(7.05172 7.05172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF9797",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8476_3699",
    x1: 39.9999,
    y1: 50.0698,
    x2: 39.9999,
    y2: 72.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8476_3699",
    x1: 39.9995,
    y1: 60.0781,
    x2: 39.9995,
    y2: 71.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8476_3699",
    x1: 39.9999,
    y1: 49.97,
    x2: 39.9999,
    y2: 59.3898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C4CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#DDE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#F0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_8476_3699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.0054 25.5763) rotate(102.47) scale(7.05172 7.05172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF9797",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8476_3699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotion5);
export default __webpack_public_path__ + "static/media/emotion5.f00f310466257b96385f4d7b395396e9.svg";
export { ForwardRef as ReactComponent };